import { render, staticRenderFns } from "./HotelReservation.vue?vue&type=template&id=6e464d0c"
import script from "./HotelReservation.vue?vue&type=script&lang=js"
export * from "./HotelReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports